var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _rect2, _rect3, _polygon, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 793.70452,
    height: 564.23642,
    viewBox: "0 0 793.70452 564.23642",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bear_market") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.496,677.27c14.41964,19.311,44.352,21.34353,44.352,21.34353s6.55351-29.27679-7.86614-48.58779-44.352-21.34353-44.352-21.34353S347.07631,657.959,361.496,677.27Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.95268,684.52954c-9.5151,12.74275-29.26658,14.08395-29.26658,14.08395s-4.32447-19.31888,5.19062-32.06163,29.26658-14.084,29.26658-14.084S444.46777,671.78678,434.95268,684.52954Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 129.1718,
    y: 529.80167,
    width: 664,
    height: 2.24072,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M968.14834,286.59706l5.78457,2.89228s31.33306,78.57367,20.728,97.37351-43.86628,53.98927-43.86628,53.98927L944.528,423.01638l25.62922-55.56407Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#575a89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M968.14834,286.59706l5.78457,2.89228s31.33306,78.57367,20.728,97.37351-43.86628,53.98927-43.86628,53.98927L944.528,423.01638l25.62922-55.56407Z",
    transform: "translate(-203.14774 -167.88179)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M961.88173,679.46542s8.1948,18.79983,3.85638,20.246-9.64094,1.44614-14.94346,1.44614-11.56913-1.92818-12.53323-3.85637,3.85638-14.46141,3.85638-14.46141Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#575a89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M851.493,689.10636s5.30252,16.87165,2.89228,17.83574-10.123,5.30252-14.46141,3.85638-11.08708-4.82047-12.53322-6.26662,0-9.15889,0-9.15889l6.74866-9.64094Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#575a89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M946.45623,438.44188l6.90994,2.41024s1.7669,16.3896-.16129,22.17416-6.26661,47.72266-3.85637,56.39951.96409,22.65621.96409,22.65621,14.46141,47.24061,11.56913,57.3636-2.41023,24.5844.48205,31.81511,5.30252,10.123,3.85637,15.90755-4.33842,8.67685-1.44614,13.49732,8.67685,6.26661,5.78457,10.605-5.78457,7.71275-4.82047,10.605-25.5485,8.1948-27.95873,3.85638c0,0,7.71275-6.74866,0-10.605s-5.30252-18.31779-5.30252-18.31779-13.49732-55.43541-13.01527-59.77383-21.21007-71.825-21.21007-71.825-31.81511,96.40942-33.7433,100.74784,2.41024,14.94346,0,17.83574.9641,10.123-2.41023,13.01527,5.78456,13.49732,0,17.3537-8.67685,15.90755-8.1948,18.31779-24.10236-.482-24.10236-3.85638.482-6.26661-1.92818-12.05118-3.85638-9.64094-1.92819-11.56913,3.37433-4.33842,1.44614-11.08708,2.89228-27.47668,1.44614-31.33306-.96409-29.88692-.96409-29.88692,4.82047-38.08171,3.37433-44.34833,0-7.71275.482-10.123,3.37433-28.44078,5.30252-32.29716,4.33842-69.89682,15.42551-73.27115S946.45623,438.44188,946.45623,438.44188Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M950.3126,696.81911s17.3537-2.89228,18.31779,0,3.85638,25.5485-2.89228,26.03054-18.31779,1.92819-20.246-2.41023-11.08708-7.23071-11.08708-7.23071-13.49732-3.85638-13.49732-8.1948.482-11.08708,2.89228-11.56913,12.05118-5.78456,12.05118-7.71275S950.3126,696.81911,950.3126,696.81911Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M841.852,704.53186s12.53322-3.85637,15.42551-1.44614,6.74866,28.92283,0,28.44078-24.5844,2.41024-25.5485-1.44614-13.97936-4.82047-13.97936-4.82047-13.97937-6.74866-13.01527-13.97937,2.41023-9.64094,8.1948-10.123,10.123-7.2307,10.605-7.71275,4.73217-4.00568,5.25837-.07465S835.5854,705.978,841.852,704.53186Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 678.23213,
    cy: 40.14159,
    r: 29.40487,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M906.92837,214.772s1.92818,32.29716,9.15889,35.18944-36.63558,2.89228-36.63558,2.89228-.482-20.246-6.74866-25.06645S906.92837,214.772,906.92837,214.772Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M918.4975,242.73077s-29.88692-11.08708-40.492,6.26661c0,0-33.74329,15.90756-36.15353,25.5485s20.246,81.948,20.246,81.948,0,59.77384-4.82047,66.04045-13.97937,13.01527-7.71276,14.46141,104.60422,12.05118,104.12217,5.78457-6.74866-11.56913,0-15.42551.9641-8.1948,5.30252-20.728,14.94346-116.17335,14.94346-116.17335-7.23071-13.01527-8.67685-14.46141S918.4975,242.73077,918.4975,242.73077Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#575a89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M832.21107,453.86739s-18.79984,42.42014-2.41024,48.20471,15.42551-44.83038,15.42551-44.83038Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M895.48448,213.4921c-1.70448-3.41525-4.256-7.35518-8.06724-7.14722-1.92718.10516-3.5891,1.30429-5.30672,2.18455s-3.91834,1.42594-5.48888.3041c-2.29721-1.6409-1.58495-5.53291-3.63974-7.46878-2.24314-2.11333-6.75476-.93343-8.20211-3.65428-.77281-1.45281-.14869-3.25538-.4857-4.86607a17.52475,17.52475,0,0,1-6.94729-.80718c-2.17634-.88215-4.06085-2.9261-4-5.27363a6.03156,6.03156,0,0,1,2.15386-4.14707c2.9633-2.69446,7.24974-3.21117,10.90637-4.84531,2.90995-1.30045,5.4402-3.32718,8.3003-4.7339,4.92243-2.42107,10.60141-2.89057,16.07107-2.47259,8.2934.63376,16.68031,3.38605,22.69427,9.13187s9.19682,14.81058,6.60314,22.71344c-1.46971,4.47815-4.58437,8.24219-6.32251,12.62314a44.18588,44.18588,0,0,0-2.20294,9.25893l-1.2203,7.4871c.18992-1.1652-2.36856-4.08784-3.20764-4.78328-1.8302-1.51691-4.49238-1.00222-6.19153-2.40728C898.41764,222.51039,896.96324,216.45506,895.48448,213.4921Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M852.93909,271.17155l-7.71275,4.82047s-12.53322,75.68139-11.08708,86.28643-5.78457,70.37887-3.37433,75.19934,3.37433,5.78456,3.37433,8.67685-6.74866,13.49731-2.41024,15.4255,20.246,5.30252,20.246,0-2.89228-12.53322,2.41023-15.90755,9.1589-25.06645,9.1589-25.06645,2.41023-22.17416,4.82047-26.51259,5.78456-20.246,5.78456-26.99463,5.78457-34.22535,2.41024-48.20471S872.221,267.31517,852.93909,271.17155Z",
    transform: "translate(-203.14774 -167.88179)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M849.56476,269.72541l-7.71275,4.82047s-12.53322,75.68139-11.08708,86.28642-5.78457,70.37888-3.37433,75.19935,3.37433,5.78456,3.37433,8.67684-6.74866,13.49732-2.41024,15.42551,20.246,5.30252,20.246,0-2.89228-12.53322,2.41024-15.90755S860.1698,419.16,860.1698,419.16s2.41024-22.17417,4.82047-26.51259,5.78457-20.246,5.78457-26.99464,5.78456-34.22534,2.41023-48.2047S868.84665,265.869,849.56476,269.72541Z",
    transform: "translate(-203.14774 -167.88179)",
    fill: "#575a89"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 567.57144,
    height: 284.75098,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.06195,
    y: 23.16618,
    width: 515.44754,
    height: 238.41862,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.156 42.513 34.791 43.878 104.007 113.093 125.725 91.375 163.852 129.503 210.667 82.688 290.301 162.322 326.498 126.124 405.649 205.276 450.051 160.874 531.416 242.238 532.781 240.873 450.051 158.144 405.649 202.546 326.498 123.395 290.301 159.592 210.667 79.958 163.852 126.773 125.725 88.645 104.007 110.364 36.156 42.513",
    fill: "#99bc85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.04586,
    cy: 82.77084,
    r: 11.58309,
    fill: "#99bc85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.37069,
    cy: 159.02618,
    r: 11.58309,
    fill: "#99bc85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.56871,
    cy: 159.02618,
    r: 11.58309,
    fill: "#99bc85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakdown);
export default __webpack_public_path__ + "static/media/breakdown.715587da22f82a3d28bdd2d807404c60.svg";
export { ForwardRef as ReactComponent };